import type { DeliveryStatus, DeliveryType } from "@types_def/models/delivery.types";

import type { FindDeliveryByIdQuery } from "@/libs/generated/operations";

/** Status from findDeliveryById API or app enum; "NEW" for unsaved. */
type ApiDeliveryStatus = FindDeliveryByIdQuery["findDeliveryById"]["status"];
export type MissionStatus = ApiDeliveryStatus | DeliveryStatus | "NEW";

export type Mission = {
  status: MissionStatus;
  origin: google.maps.LatLngLiteral;
  destination: google.maps.LatLngLiteral;
  toReturn: google.maps.LatLngLiteral;
  restitution: string;
  type: DeliveryType;
  id: string;
  color: string;
  depart: string;
  arrive: string;
  originCity?: string;
  destinationCity?: string;
  driver?: {
    id: string;
    name: string;
    avatar: string;
  };
};

export enum PreviewType {
  AB,
  BC,
  ABC,
}
